import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_wdbH1H1BwzTW: {
	id: 'prd_wdbH12DEV2H1BwzTW'
	ident: 'prd_wdbH1H1BwzTW'
	sku: 'simple_premium_1w_6_23_4w_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 1
			iteration_count: 1
			price_id: 'prc_sZtPZ2DEV2jkh08LF'
			amount: 22
			amount_usd: 6.23
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 6.23
			discount: 15.77
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_k8Jb72DEV2z4xmAVV'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_wdbH1H1BwzTW, SubscriptionProduct>
const prd_wdbH1H1BwzTW = { ident: 'prd_wdbH1H1BwzTW' } as typeof _prd_wdbH1H1BwzTW

export default prd_wdbH1H1BwzTW
